import api, { authService } from './api';

export const venuesService = {
  listVenues: async ({ q, limit = 5000 } = {}) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.get('/venues', {
        params: { q, limit },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        items: response.data.items || [],
        totalCount: response.data.total_count || 0,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch venues',
      };
    }
  },

  createVenue: async (payload) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.post('/venues', payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        item: response.data.item,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to create venue',
      };
    }
  },

  updateVenue: async (venueId, payload) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.patch(`/venues/${encodeURIComponent(venueId)}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        item: response.data.item,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to update venue',
      };
    }
  },

  listAliases: async (venueId) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.get(`/venues/${encodeURIComponent(venueId)}/aliases`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        items: response.data.items || [],
        totalCount: response.data.total_count || 0,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch venue aliases',
      };
    }
  },

  addAlias: async (venueId, aliasName, source = 'manual') => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.post(`/venues/${encodeURIComponent(venueId)}/aliases`, {
        alias_name: aliasName,
        source,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        item: response.data.item,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to add venue alias',
      };
    }
  },

  mergeVenue: async (sourceVenueId, targetVenueId) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.post(`/venues/${encodeURIComponent(sourceVenueId)}/merge`, {
        target_venue_id: targetVenueId,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        item: response.data.item,
        mergedVenueId: response.data.merged_venue_id,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to merge venue',
      };
    }
  },

  deleteVenue: async (venueId) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.delete(`/venues/${encodeURIComponent(venueId)}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to delete venue',
      };
    }
  },
};
